import { ActivityLogSourceSubType, ActivityLogSourceType } from 'cio/utils/activity-log-source-types';
import { FormType } from 'cio/utils/forms';
import { ActionType } from 'cio/models/action';
import { CampaignType } from 'cio/models/campaign';

export enum ActivityLogSourceClientType {
  Rest = 'cio-client-rest',
  Go = 'cio-client-go',
  iOS = 'cio-client-ios',
  Android = 'cio-client-android',
  Node = 'cio-client-node',
  Ruby = 'cio-client-ruby',
  Python = 'cio-client-python',
  ReactNative = 'cio-client-react-native',
}

export interface ActivityLogSourceClient {
  type: ActivityLogSourceClientType;
  version: string;
  deviceInfo: string;
  osInfo: string;
  customerAppName: string;
  customerAppVersion: string;
}

export interface ActivityLogSource {
  type: ActivityLogSourceType;
  email: string;
  environmentId: number;
  campaignId: number;
  campaignName: string;
  importId: number;
  api: string;
  ua: string;
  ipAddr: string;
  siteId: string;
  formType: FormType;
  formId: string;
  anonymousId: string;
  subtype: ActivityLogSourceSubType;
  actionId: string;
  actionType: ActionType;
  actionName: string;
  newsletterId: string;
  newsletterName: string;
  transactionalMessageId: string;
  transactionalMessageName: string;
  subjectId: string;
  customerId: string;
  campaignType: CampaignType;
  client: ActivityLogSourceClient;
}
